import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControlLabel from '@mui/material/FormControlLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import { closePopup } from '../../actions/uiActions';
import { sendEditUser } from '../../actions/userActions';
import CloseIcon from '@mui/icons-material/Close';

class EditUser extends React.Component {
    state = {
        firstName: "",
        lastName: "",
        username: "",
        customerID: null,
        role: "",
        teamIDs: [],
        claims: [],
        isEnabled: false,
    }

    componentDidMount() {
        let user = this.props.userList.find(x => x.id === this.props.popupInfo[0])
        this.setState({
            firstName: user.firstName,
            lastName: user.lastName,
            username: user.userName,
            customerID: user.customerID,
            role: user.applicationUserRoles[0].role.name,
            teamIDs: (user.applicationUserTeams !== null) ? user.applicationUserTeams.map(x => x.team.id) : [],
            claims: (user.applicationUserClaims !== null) ? user.applicationUserClaims.map(x => x.claimValue) : [],
            isEnabled: user.isEnabled
        })
    }

    changeFName = (event) => {
        this.setState({ firstName: event.target.value })
    }

    changeLName = (event) => {
        this.setState({ lastName: event.target.value })
    }

    handleClick = (event) => {
        event.preventDefault()
        this.props.closePopup()
    }

    handleSubmit = (event) => {
        event.preventDefault()
        this.props.sendEditUser(this.props.popupInfo[0], this.state.firstName, this.state.lastName, this.state.username, this.state.customerID, this.state.role, this.state.teamIDs, this.state.isEnabled, this.state.claims)
    }

    handleCustomerID = (event) => {
        event.preventDefault()
        this.setState({ customerID: event.target.value })
    }

    handleRole = (event) => {
        event.preventDefault()
        
        this.setState({ role: event.target.value })
    }

    handleEnabled = (event) => {
        event.preventDefault()
        this.setState({ isEnabled: event.target.value })
    }

    handleCheckBoxes = (event) => {
        let ind = this.state.teamIDs.findIndex(x => x === parseInt(event.target.value))
        let arr = this.state.teamIDs
        if (ind !== -1) {
            arr.splice(ind, 1)
        } else {
            arr.push(parseInt(event.target.value))
        }
        this.setState({ teamIDs: arr })
    }

    handleClaimsCheckBoxes = (event) => {
        let ind = this.state.claims.findIndex(x => x === event.target.value)
        let arr = this.state.claims
        if (ind !== -1) {
            arr.splice(ind, 1)
        } else {
            arr.push(event.target.value)
        }
        this.setState({ claims: arr })
    }

    populateCustomers = () => {
        if (this.props.role === "IEAdmin") {
            return (<>
                <h5 className="mainLable">Customer:</h5>
                <div className="myInputOut">
                    <Select
                        className="myInput"
                        onChange={this.handleCustomerID}
                        value={this.state.customerID}
                        displayEmpty
                        inputProps={{ 'aria-label': 'Without label' }}
                    >
                        <MenuItem value="" disabled hidden>
                            Select
                            </MenuItem>
                        {this.props.customerList.map((x) => <MenuItem key={x.id} value={x.id}>{x.name}</MenuItem>)}
                    </Select>
                </div>
            </>)
        }

        return null
    }

    populateRoles = () => {
        if (this.props.role === "IEAdmin") {
            return (
                <div>
                    <h5 className="mainLable">Role:</h5>
                    <div className="myInputOut">
                        <Select
                            className="myInput"
                            defaultValue={this.state.role}
                            onChange={this.handleRole}
                            value={this.state.role}
                            displayEmpty
                            inputProps={{ 'aria-label': 'Without label' }}
                        >
                            <MenuItem value="" disabled hidden>Select</MenuItem>
                            <MenuItem key={1} value={"IEAdmin"}>IEAdmin</MenuItem>
                            <MenuItem key={4} value={"ClientAdmin"}>Client Admin</MenuItem>
                            <MenuItem key={2} value={"Builder"}>Builder</MenuItem>
                            <MenuItem key={3} value={"Viewer"}>Viewer</MenuItem>
                        </Select>  
                    </div>
                </div>
            )
        } else if (this.props.role === "ClientAdmin") {
            return (
                <div>
                    <h5 className="mainLable">Role:</h5>
                    <div className="myInputOut">
                        <Select
                            className="myInput"
                            defaultValue={this.state.role}
                            onChange={this.handleRole}
                            value={this.state.role}
                            displayEmpty
                            inputProps={{ 'aria-label': 'Without label' }}
                        >
                            <MenuItem value="" disabled hidden>Select</MenuItem>
                            <MenuItem key={4} value={"ClientAdmin"}>Client Admin</MenuItem>
                            <MenuItem key={2} value={"Builder"}>Builder</MenuItem>
                            <MenuItem key={3} value={"Viewer"}>Viewer</MenuItem>
                        </Select>  
                    </div>
                </div>
            )
        }

        return null
    }

    populateTeamCheckBoxes = () => {
        if (this.state.customerID !== null && (this.props.role === "IEAdmin" || this.props.role === "ClientAdmin")) {
            let teams = this.props.customerList.find(x => x.id === this.state.customerID).teams
            return (<div className="checkOut">
                <label className="checkHead">Teams:</label>
                <ul>
                    {teams.map(x => (
                        <li key={x.id}>
                            <FormControlLabel
                                control={(
                                    <Checkbox
                                        key={x.id} onChange={this.handleCheckBoxes}
                                        name="checkedA"
                                        defaultChecked={(this.state.teamIDs.find(y => y === x.id) !== undefined) ? true : false}
                                        value={x.id}
                                    />
                                )}
                                label={x.name}
                            />
                        </li>
                    ))}
                </ul>
            </div>)
        }
        return (<div />)
    }

    populateClaims = () => {
        return (<ul>
            {this.props.permissionsList.map((x) => {
                return (<li key={`permission-${x.permissionValue}`}>
                    <FormControlLabel
                        control={(
                            <Checkbox
                                name={x.permissionValue}
                                checked={(this.state.claims.find(y => y === x.permissionValue) !== undefined) ? true : false}
                                value={x.permissionValue}
                                onChange={this.handleClaimsCheckBoxes}
                            />
                        )}
                        label={x.label}
                    />
                </li>)
            })}
        </ul>)
    }

    populateEnabled = () => {
        return (
            <Select
                className="myInput"
                defaultValue=""
                onChange={this.handleEnabled}
                value={this.state.isEnabled}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
            >
                <MenuItem value="" disabled hidden>Select</MenuItem>
                <MenuItem key={1} value={true}>True</MenuItem>
                <MenuItem key={2} value={false}>False</MenuItem>
            </Select>
        )
    }

    render() {
        return (
            <Dialog
                open={true}
                onClose={this.handleClick}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <CloseIcon onClick={this.handleClick} className="closePoup" />
                <DialogTitle id="alert-dialog-title" className="changepassdialog">
                    {'Edit User'}
                    {' '}
                </DialogTitle>
                <DialogContent>
                    <form onSubmit={this.handleSubmit}>
                        <div className="myInputOut">
                            <input
                                type="text"
                                className="myInput"
                                onChange={this.changeFName}
                                value={(this.state.firstName) !== null ? this.state.firstName : ""}
                                placeholder="First Name"
                            />
                        </div>
                        <div className="myInputOut">
                            <input
                                type="text"
                                className="myInput"
                                onChange={this.changeLName}
                                value={(this.state.lastName) !== null ? this.state.lastName : ""}
                                placeholder="Last Name"
                            />
                        </div>
                        <div className="myInputOut">
                            <input
                                type="text"
                                className="myInput"
                                value={this.state.username}
                                readOnly
                            />
                        </div>
                        <div className="adminSelectbox">
                            {this.populateCustomers()}
                            {this.populateRoles()}
                            {this.populateTeamCheckBoxes()}
                            <div className="checkOut">
                                <label className="checkHead">Permissions:</label>
                                {this.populateClaims()}
                            </div>
                            <div className="checkOut">
                                <label>Enabled:</label>
                                <div className="myInputOut">
                                    {this.populateEnabled()}
                                </div>
                            </div>
                        </div>
                        <div>
                            <button className="btn" type="submit" value="Submit" id="submit_btn">
                                Submit
                            </button>
                        </div>
                    </form>
                </DialogContent>
            </Dialog>
        )
    }
}

function mapStateToProps(state) {
    return {
        popupInfo: state.ui.popupInfo,
        userList: state.users.data,
        customerList: state.users.customerList,
        permissionsList: state.users.permissionsList,
        role: state.users.role
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ closePopup, sendEditUser }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditUser)